import { get } from 'lodash'
import * as actionTypes from './actionTypes'

export const namespace = 'system'

export const initialState = {
  globalVersion: '',
  lastDeploymentDate: '',
  environment: '',
  lastImportedYMFileDate: '',
  versionLoading: false,
  versionError: null,
}

const getPath = (path, state) => get(state, `${namespace}.${path}`)
export const selectors = {
  getGlobalVersion: getPath.bind(null, 'globalVersion'),
  getLastDeploymentDate: getPath.bind(null, 'lastDeploymentDate'),
  getEnvironment: getPath.bind(null, 'environment'),
  isVersionLoading: getPath.bind(null, 'versionLoading'),
  getVersionError: getPath.bind(null, 'versionError'),
  getLastImportedYMFileDate: getPath.bind(null, 'lastImportedYMFileDate'),
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VERSION:
      return { ...state, [namespace]: { ...state[namespace], ...action.payload } }
    case actionTypes.SET_VERSION_LOADING:
      return { ...state, [namespace]: { ...state[namespace], versionLoading: action.payload } }
    case actionTypes.SET_VERSION_ERROR:
      return { ...state, [namespace]: { ...state[namespace], versionError: action.payload } }
    default:
      return state
  }
}
